import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DateTimeTZoneSelector.html?raw';

import TimeInput from '../TimeInput/TimeInput';
import '../TimeInput/TimeInput';
import DateInput from '../DateInput/DateInput';
import '../DateInput/DateInput';
import TimeZoneSelector from '../TimeZoneSelector/TimeZoneSelector';
import "../TimeZoneSelector/TimeZoneSelector";

import docu from './DateTimeTZoneSelectorDocumentation.html?raw';



interface _value {
    date: Date, // local Date -- convertiert tu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! ()
    timezone: string // Intl.DateTimeFormat().resolvedOptions().timeZone - wenn ohne TimeZoneSelector || TimeZoneSelector._value.timezone
}
class DateTimeTZoneSelector extends compose(_LabelInputBase) {
    templateString: any = template;

    DateTimeInput_container: HTMLElement;
    TZSelector_container: HTMLElement;
    mainContainer: HTMLElement;

    protected date_input: MdsLax<InstanceType<typeof DateInput>>;
    protected time_input: MdsLax<InstanceType<typeof TimeInput>>;
    TimeZoneSelector: MdsLax<InstanceType<typeof TimeZoneSelector>>;

    _date_UTC: Date; //// ACHTUNG!!!! Gibt immer das UTC Date, kaluliert mit dem lokalen TimezoneOffset!!!
    utcOffset: number; // local TimeZoneOffset

    _value: _value = {
        date: null, // local Date!!  convertiert zu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! 
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone //LOCALE Timezone, für UTC Values und andere TimeZonen aktiviere den TimezonSelector
    };
    
    _is_TimeZoneSelector: boolean = true;

    ////TimeZoneSelector Methods ------------------------------------------------------------------------START
    _onValueChangeTzSelector(): void {
        if (this.TimeZoneSelector.inputDate) {
            this.setValue(this.TimeZoneSelector.getSelectedLocaleDate_Date());
        }
    }

    _onValueChangeTzDateTime(): void { //valueChangeEmit HERE !
        this.TimeZoneSelector.setInputDate(this._value.date);
    }

    enableTimeZoneSelector(): void {
        this.set_is_TimeZoneSelector(true);

        this.getValue = function () {
            return this.TimeZoneSelector.getValue();
        }

        this.UiModder.domClass.remove(this.TZSelector_container, "w3-hide");
        this.UiModder.domClass.add(this.TZSelector_container, "w3-col");
        this.UiModder.domClass.add(this.TZSelector_container, "m6");

        this.UiModder.domClass.remove(this.DateTimeInput_container, "w3-row-padding");
        this.UiModder.domClass.add(this.DateTimeInput_container, "w3-col");
        this.UiModder.domClass.add(this.DateTimeInput_container, "m6");

        this.UiModder.domClass.add(this.mainContainer, "w3-row-padding");
    }

    disableTimeZoneSelector(): void {

        this.set_is_TimeZoneSelector(false);

        this.getValue = function () {
            return this._value;
        }

        this.UiModder.domClass.add(this.TZSelector_container, "w3-hide");
        this.UiModder.domClass.remove(this.TZSelector_container, "w3-col");
        this.UiModder.domClass.remove(this.TZSelector_container, "m6");

        this.UiModder.domClass.add(this.DateTimeInput_container, "w3-row-padding");
        this.UiModder.domClass.remove(this.DateTimeInput_container, "w3-col");
        this.UiModder.domClass.remove(this.DateTimeInput_container, "m6");

        this.UiModder.domClass.remove(this.mainContainer, "w3-row-padding");
    }
    ////TimeZoneSelector Methods ------------------------------------------------------------------------END

    ////DATETIME METHODS ------------------------------------------------------------------------START
    

    _onValueChangeTime(): void {
        this.setValue();
    }

    _onValueChangeDate(): void {
        this.setValue();
    }

    getValue(): _value {
        return this._value;
    }

    setUtcOffset(value: number): void {
        this.utcOffset = value;
    }

    getUtcOffset(): number {
        return this.utcOffset;
    }

    setMaxTime(maxTime: string): void {
        this.time_input.setMaxTime(maxTime);
    }

    setMinTime(minTime: string): void {
        this.time_input.setMinTime(minTime);
    }

    getUTCDate(): Date {
        return this._date_UTC; // ACHTUNG!!!! Gibt immer das UTC Date, kaluliert mit dem lokalen TimezoneOffset!!!
    }

    setMandatory(bMandatory: boolean = true): void {

        this.date_input.setMandatory(bMandatory);
        this.time_input.setMandatory(bMandatory);
        this.TimeZoneSelector.inputNode.setMandatory(bMandatory);

    }

    set_is_TimeZoneSelector(value: boolean): void {
        this._is_TimeZoneSelector = value;
    }

    get_is_TimeZoneSelector(): boolean {
        return this._is_TimeZoneSelector;
    }


    timeInput_DateToString(randomDate: Date): string {
        let hours: string = ("0" + randomDate.getHours()).slice(-2); // HH
        let min: string = ("0" + randomDate.getMinutes()).slice(-2);  // mm
        //HH:mm
        let timeString = `${hours}:${min}`
        return timeString;
    }

    protected setInputValue(newValue?: Date): void {
        this.date_input.setValue(newValue);
        this.time_input.setValue(newValue);
    }


    setValue(newValue?: Date): void {

        this._value.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Locale IANA TimeZone_Id (Name)

        if (newValue) {
            if (Object.prototype.toString.call(newValue) === "[object Date]") {
                if (!isNaN(newValue.getFullYear())) {
                    this._value.date = newValue;
                    this.setInputValue(newValue);
                }
            }
        } else {

            if (this.date_input.getValue()) {

                let dateInputValue: Date = this.date_input.getValue();
                let timeString: string;
                let dateString: string;
                let stringValue: string;

                if (Object.prototype.toString.call(dateInputValue) === "[object Date]") {
                    if (!isNaN(dateInputValue.getFullYear())) {
                        dateString = this.date_input.toStringISO(this.date_input.getValue()).slice(0, 10);
                    }
                }

                if (this.time_input.getValue()) {
                    timeString = this.timeInput_DateToString(this.time_input.getValue());
                } else {
                    timeString = this.time_input.getMinTime();
                }

                stringValue = dateString + ", " + timeString;

                let dateTimeObject = new Date(stringValue); // locale DateTime

                this._value.date = dateTimeObject;
                this.utcOffset = dateTimeObject.getTimezoneOffset();
                this._date_UTC = this.convertDateToUTC(dateTimeObject); // ACHTUNG!!!! Gibt immer das UTC Date, kaluliert mit dem lokalen TimezoneOffset!!!

                this.setInputValue(dateTimeObject);
            }
        }

        this._onValueChangeTzDateTime();
        this.emit('valueChange');
    }

    // DATE

    /*
     dateObject.getTimezoneOffset() // Returns the time difference between UTC time and local time, in minutes
     dateObject.toUTCString() // Converts a Date object to a string, according to UTC
     dateObject.toISOString() //Returns the date as a string, using the ISO standard
     
     */

    convertDateToUTC(date: Date): Date {

        let now_utc: number = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

        return new Date(now_utc + this.utcOffset * 60);

    }

    toStringISO(date: Date): string {
        if (date) {
            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear(); //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
            return ISOString;
        }

        return null;
    }

    ISOStringToInputValues(iso: string): object {
        let value: object;
        if (iso) {
            let dateString = iso.slice(0, 10);
            let timeString = iso.slice(-8);
            value = { date: dateString, time: timeString };
            return value;
        }

        value = { date: null, time: null }
        return value;
    }

    // takes an ISO Date Sttring as a param, turns it in separate date and time values, and sends them to setValue() respectively

    setValueFromString(iso: string): void {
        this.setValue(new Date(iso));
    }

    // Labels

    setDateLabel(newValue: string): void {
        this.date_input.setLabel(newValue);
    }

    setTimeLabel(newValue: string): void {
        this.time_input.setLabel(newValue);
    }

    setTimeZoneSelectorLabel(newValue: string): void {
        this.TimeZoneSelector.setLabel(newValue);
    }

    getDateLabel(): string {
        return this.date_input.getLabel();
    }

    getTimeLabel(): string {
        return this.time_input.getLabel();
    }


    // docu
    getDocumentationContent(): string {
        return docu;
    }

    // dojo

    _setMinTimeAttr(minTime: string): void {
        this.setMinTime(minTime);
    }

    _setMaxTimeAttr(maxTime: string): void {
        this.setMinTime(maxTime);
    }

    _getValueAttr(): _value {
        return this.getValue();
    }

    _setDateLabelAttr(newValue: string): void {
        this.setDateLabel(newValue);
    }

    _getDateLabelAttr(): string {
        return this.getDateLabel();
    }

    _getTimeLabelAttr(): string {
        return this.getTimeLabel();
    }

    _setis_TimeZoneSelectorAttr(bool: boolean) {
        this.set_is_TimeZoneSelector(bool);
    }

    _setTimeLabelAttr(newValue: string): void {
        this.setDateLabel(newValue);
    }

    _setTZSelectorLabel(newValue: string): void {
        this.setTimeZoneSelectorLabel(newValue);
    }

    ////DATETIME METHODS ------------------------------------------------------------------------END

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.utcOffset = new Date().getTimezoneOffset();

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this._is_TimeZoneSelector) {
            this.enableTimeZoneSelector();
        }
    }
}

export default mdsWidget(DateTimeTZoneSelector);




